import request from '@/utils/http'

const PREFIX = '/dashboard'

const dashboard = {
  totalPua(params) {
    return request(
      `${PREFIX}/total/pua/v1`,
      'post',
      params
    )
  },

  trendPua(params) {
    return request(
      `${PREFIX}/trend/pua`,
      'post',
      params
    )
  },

  pageChannel(params) {
    return request(
      `${PREFIX}/pageChannel`,
      'post',
      params
    )
  },
  trendChannel(params) {
    return request(
      `${PREFIX}/trendChannel`,
      'post',
      params
    )
  },

  pagePage(params) {
    return request(
      `${PREFIX}/pagePage`,
      'post',
      params
    )
  },
  trendPage(params) {
    return request(
      `${PREFIX}/trendPage`,
      'post',
      params
    )
  },

  pageEvent(params) {
    return request(
      `${PREFIX}/pageEvent`,
      'post',
      params
    )
  },
  trendEvent(params) {
    return request(
      `${PREFIX}/trendEvent`,
      'post',
      params
    )
  },

  pageScene(params) {
    return request(
      `${PREFIX}/pageScene`,
      'post',
      params
    )
  },
  trendScene(params) {
    return request(
      `${PREFIX}/trendScene`,
      'post',
      params
    )
  }
}

export default dashboard
